import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, deleteToken } from 'firebase/messaging';
import { EventEmitter } from 'events';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};
const vabidKey = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;
// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Messaging
export const messaging = getMessaging(app);

// Request permission and get the FCM token
export const requestFCMToken = async () => {
  return Notification.requestPermission()
    .then((permission) => {
      if (permission === 'granted') {
        return getToken(messaging, { vabidKey });
      } else {
        throw new Error('Notification not granted');
      }
    })
    .catch((err) => {
      console.error('Error getting FCM token: ', err);

      throw err;
    });
};

// Create a single event emitter instance
const notificationEmitter = new EventEmitter();
export const setupMessageListener = () => {
  onMessage(messaging, (payload) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Only emit if token exists
      notificationEmitter.emit('message', payload);
    } else {
      console.log('Foreground message ignored (no token):', payload);
    }
  });
};

// Export the emitter for other parts of the app to use
export const onNotification = (handler) => {
  notificationEmitter.on('message', handler);
  return () => notificationEmitter.off('message', handler);
};

export { deleteToken };
